import React from 'react';
import {IconButton} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';

export const DeleteButton = ({onClick, disabled}) => {
    return <IconButton onClick={onClick} disabled={disabled}>
        <DeleteIcon/>
    </IconButton>
}